import React, { useEffect, useState } from 'react';
import LoadingWrapper from '../../Shared/LoadingWrapper';
import Table from 'react-bootstrap/Table';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import TableHeader from '../../Shared/TableHeader';
import ReactPagination from '../../Shared/Pagination';
import { sortingTableData } from '../../../Services/_actions/sorting.action';
import APIService from '../../../Services/APIService';
import { BackButton } from '../../Shared/BackButton/index';

export default function EntityCitywiseCount(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { name, supplier_type } = location.state;
  const headerValue = `Citywise Report - ${name}`;
  const [entityData, setEntityData] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [paginationData, setPagination] = useState({
    page: 0,
    total_count: 0,
  });
  const [sorting, setSorting] = useState({ sortingKey: '', sortReverse: false });

  const getEntityData = async (filters) => {
    let res = await APIService.get(
      `/v0/ui/ops/get-supplier-summary-city-wise/?supplier_type=${supplier_type}&next_page=${
        filters?.page + 1
      }`
    );
    if (res.status == 200) {
      setEntityData(res?.data?.list);
      setPagination({ page: filters?.page, total_count: res?.data?.total_count });
    }
    setIsDataFetched(true);
  };

  const handlePageChange = (event) => {
    setIsDataFetched(false);
    let obj = { ...paginationData, page: event.selected };
    getEntityData(obj);
  };
  const sortingData = (tableData, accessKey, reverse, type) => {
    let newList = sortingTableData(tableData, accessKey, reverse, type);
    setSorting({ sortReverse: !sorting.sortReverse, sortingKey: accessKey });
    setEntityData(newList);
  };

  useEffect(() => {
    getEntityData(paginationData);
  }, []);
  const backButton = () => {
    return <BackButton onClick={() => navigate(`/r/operations-dashboard/entity`)} />;
  };
  return (
    <>
      <TableHeader headerValue={headerValue} isBackButton={backButton} />
      {isDataFetched ? (
        <div>
          <Table responsive className={`react-bootstrap-custom-table v-middle`}>
            <thead>
              {' '}
              <tr style={({ padding: '8px 14px' }, { whiteSpace: 'nowrap' })}>
                <th
                  rowSpan="2"
                  className={`sortable-custom ${
                    sorting.sortingKey == 'city' ? `${sorting.sortReverse ? 'asc' : 'desc'}` : ''
                  }`}
                  onClick={(e) => {
                    sortingData(entityData, 'city', sorting.sortReverse);
                  }}
                >
                  City
                </th>
                <th
                  rowSpan="2"
                  className={`sortable-custom ${
                    sorting.sortingKey == 'count' ? `${sorting.sortReverse ? 'asc' : 'desc'}` : ''
                  }`}
                  onClick={(e) => {
                    sortingData(entityData, 'count', sorting.sortReverse, 'Number');
                  }}
                >
                  Count
                </th>
                <th colSpan="3">Contact Name</th>
                <th colSpan="3">Contact Number</th>
                <th colSpan="3">Contact Number(Decision Maker)</th>
                <th colSpan="4">Entity Count</th>
              </tr>
              <tr>
                <th>Filled(Unique)</th>
                <th>Total Filled</th>
                <th>Not Filled</th>
                <th>Filled(Unique)</th>
                <th>Total Filled</th>
                <th>Not Filled</th>
                <th>Filled(Unique)</th>
                <th>Total Filled</th>
                <th>Not Filled</th>
                <th>Today's Count(% inc from yesterday)</th>
                <th>This Week Count(% inc from last week)</th>
                <th>This Month Count(% inc from last month)</th>
                <th>Last 3 Months Count</th>
              </tr>
            </thead>
            <tbody id="rows">
              {entityData?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item?.city}</td>
                    <td>
                      {item?.count && item?.count > 0 ? (
                        <Link
                          style={{ color: '#3e59e3' }}
                          to={`${item?.city}`}
                          state={{
                            supplier_type: item?.supplier_type,
                            city: item?.city,
                          }}
                        >
                          {item?.count}
                        </Link>
                      ) : (
                        0
                      )}
                    </td>
                    {index == 0 && (
                      <td
                        colSpan={13}
                        rowSpan={10}
                        style={{ background: '#eee', textAlign: 'center', verticalAlign: 'middle' }}
                      >
                        Coming Soon
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <ReactPagination
            pageNo={paginationData.page}
            pageSize={10}
            totalItems={paginationData.total_count}
            onPageChange={handlePageChange}
          />
        </div>
      ) : (
        <LoadingWrapper />
      )}
    </>
  );
}
